import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Order Model
import VuexORM from '@vuex-orm/core';
import Invoice from "./Invoice";
import Product from "./Product";
import Price from "./Price";
import Company from "./Company";
import Flyer from "./Flyer";
var Order = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Order, _VuexORM$Model);
  var _super = _createSuper(Order);
  function Order() {
    _classCallCheck(this, Order);
    return _super.apply(this, arguments);
  }
  _createClass(Order, null, [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'orders';
    }

    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        company: this.belongsTo(Company, 'company_id'),
        product: this.belongsTo(Product, 'product_id'),
        invoice_id: this.belongsTo(Invoice, 'invoice_id'),
        price: this.belongsTo(Price, 'price_id'),
        flyer: this.belongsTo(Flyer, 'flyer_id'),
        product_name: this.attr(null),
        order_date: this.attr(null),
        status: this.attr(null),
        created_at: this.attr(null),
        updated_at: this.attr(null)
      };
    }
  }]);
  return Order;
}(VuexORM.Model);
export { Order as default };